var codeblock_default = {
  "blockStyleSpacing": "V4Kb-",
  "codeBlock": "tGFnt V4Kb-",
  "renderedInTable": "beSon"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
